import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Cancel} from '@material-ui/icons';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';

class BasicDateInput extends Component {
    state = {
        emptyValidation: true,
        focus: false,
        firstAssignValue: true,
        legalEmail: true,
        legalPhone: true,
        minShippingPlanDate: new Date().toISOString().split('T')[0],
    };

    componentWillReceiveProps(nextProps) {
        if (this.input) {
            if (
                this.state.firstAssignValue &&
                util.isString(nextProps.defalutValue)
            ) {
                this.input.value = nextProps.defalutValue;
                this.props.inputValid(this.props.title, nextProps.defalutValue);

                this.setState({
                    firstAssignValue: false,
                });
            } else if (
                nextProps.value !== this.input.value &&
                util.isString(nextProps.value)
            ) {
                this.input.value = nextProps.value;
            }
        }
    }

    clearInput = () => {
        this.input.value = '';

        if (
            typeof this.props.checkEmail !== 'undefined' &&
            this.props.checkEmail
        ) {
            this.setState({
                emptyValidation: false,
            });
        } else if (
            typeof this.props.checkShipToPhone !== 'undefined' &&
            this.props.checkShipToPhone
        ) {
            this.setState({
                emptyValidation: false,
            });
        }
        this.props.inputValid(this.props.title, '');
    };

    foucusInput = (title) => (event) => {
        let empty = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }
        this.setState({
            focus: true,
        });

        this.setState({
            emptyValidation: empty,
        });
        this.props.inputValid(title, event.target.value);

        if (util.isFunction(this.props.blurFoucus)) {
            this.props.blurFoucus();
        }
    };

    blurAction = () => {
        setTimeout(() => {
            this.setState({
                focus: false,
            });
            if (util.isFunction(this.props.blurAction)) {
                this.props.blurAction();
            }
        }, 200);

        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };

    inputValid = (title) => (event) => {
        let empty = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }

        this.setState({
            emptyValidation: empty,
        });
        this.props.inputValid(title, event.target.value);
    };

    render() {
        const {
            title,
            placeholder,
            type,
            disabled,
            defaultValue,
            value,
            smallBasicInput,
            checkEmail,
        } = this.props;
        const {emptyValidation, focus, minShippingPlanDate} = this.state;

        return (
            <div className="basic-input-container">
                <div
                    className={
                        emptyValidation
                            ? typeof checkEmail !== 'undefined'
                                ? 'basic-input eamil-basic-input'
                                : 'basic-input'
                            : 'basic-input empty'
                    }>
                    <input
                        className={
                            util.getPropertyExistsAndIsTrue(smallBasicInput)
                                ? 'input-content small-input-content'
                                : 'input-content'
                        }
                        onChange={this.inputValid(title)}
                        placeholder={
                            emptyValidation
                                ? T(placeholder)
                                : T('input_required')
                        }
                        type={type || 'text'}
                        defaultValue={defaultValue || ''}
                        value={value || null}
                        min={minShippingPlanDate}
                        ref={(input) => (this.input = input)}
                        onBlur={this.blurAction}
                        onFocus={this.foucusInput(title)}
                        disabled={disabled}
                    />
                    {this.input && this.input.value && focus ? (
                        <Cancel
                            className="cancel-button"
                            onClick={this.clearInput}
                        />
                    ) : null}
                </div>
            </div>
        );
    }
}

BasicDateInput.propTypes = {
    title: PropTypes.string.isRequired,
};

export default BasicDateInput;
